module.exports = __webpack_public_path__ + "static/media/codeblockBlueLogo.e350d28a.png";